import React from "react";
// react router
import { useHistory } from "react-router-dom";

// reactstrap components
import {
  Container,
  Row,
  Button,
  Col,
  Card,
  CardImg,
  CardText,
  CardTitle,
  CardBody,
} from "reactstrap";

// core components
import AuthHeader from "components/Headers/AuthHeader.js";

function ProInvitation({ proFeature }) {

  const history = useHistory();

  return (
    <>
      <AuthHeader title="This is a Pro feature that you are missing out on!" lead="Take a look at what you are missing!" />
      <Container className="mt--8 pb-5 bg-default" style={{minWidth: '100%'}}>
        <Row className="justify-content-center">
          <Col xl="10">
            <Card>
              <div className="d-flex justify-content-center p-3">
                <CardImg
                  alt="Pro Image"
                  src={ proFeature === 'calendar' ? require('assets/img/pro/locations-calendar.png').default : require('assets/img/pro/users-calendar.png').default}
                  top
                />
              </div>

              <CardBody>
                <CardTitle className="h2 mb-0">View the daily history of your checklists</CardTitle>
                <CardText className="mt-4">
                  {
                    proFeature === 'calendar' ? "See what checklists were completed on time, passed, and not completed on a per-day basis. Comparing this to your customer's feedback will give you the tools to improve your service and improve your customer satisfaction."
                    : "See the performance of each manager. Being able to see if they are completing their duties on time and completing them thoroughly will give you the tools to coach them and help them improve where they have areas of opportunity."
                  }
                </CardText>
                <Button
                  color="primary"
                  onClick={e => history.push("/admin/billing")}
                >
                  Upgrade to Pro
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col xl="10">
            <Card>
              <div className="d-flex justify-content-center p-3">
                <CardImg
                  alt="Pro Image"
                  src={ proFeature === 'calendar' ? require('assets/img/pro/locations-calendar-details.png').default : require('assets/img/pro/users-calendar-details.png').default}
                  top
                />
              </div>

              <CardBody>
                <CardTitle className="h2 mb-0">View each checklist details</CardTitle>
                <CardText className="mt-4">
                  {
                    proFeature === 'calendar' ? "See the details of the checklist. Who completed it, when, and if they were missing something."
                    : "See which checklists your managers are completing and which ones they aren't. Which ones are late, and which ones are complete to improve the organization's efficiency."
                  }
                </CardText>
                <Button
                  color="primary"
                  onClick={e => history.push("/admin/billing")}
                >
                  Upgrade to Pro
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ProInvitation;